import { render, staticRenderFns } from "./ServiceFeeForm.vue?vue&type=template&id=63db1099&scoped=true&"
import script from "./ServiceFeeForm.vue?vue&type=script&lang=js&"
export * from "./ServiceFeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db1099",
  null
  
)

export default component.exports